import React from 'react';
import { Drawer, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

function LayerPanel() {
  const layers = [
    { id: 1, name: 'レイヤー1' },
    { id: 2, name: 'レイヤー2' },
  ];

  return (
    <Drawer variant="permanent" anchor="left">
      <List>
        {layers.map((layer) => (
          <ListItem key={layer.id}>
            <ListItemText primary={layer.name} />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete">
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
}

export default LayerPanel;